export const PLATFORM_CAPABILITY_ROLES = [
    'owner',
    'platform_admin',
    'support_agent',
    'platform_finance',
    'contact_person',
];
export const OWNER_CONSOLE_CAPABILITY_ROLES = ['owner', 'platform_admin', 'support_agent', 'platform_finance'];
export const OWNER_MENU_KEYS = [
    'overview',
    'tenants',
    'facility_requests',
    'branch_requests',
    'contacts',
    'offline_installs',
    'traffic',
    'alerts',
    'mail',
    'renewals',
    'tickets',
    'plans',
    'person_changes',
    'releases',
    'owners',
    'staff',
    'backups',
    'deletion_backups',
    'owner_audit',
];
const O = ['owner'];
const OA = ['owner', 'platform_admin'];
const OAS = ['owner', 'platform_admin', 'support_agent'];
const OASF = ['owner', 'platform_admin', 'support_agent', 'platform_finance'];
const OF = ['owner', 'platform_finance'];
const OAF = ['owner', 'platform_admin', 'platform_finance'];
const CLIENT = ['contact_person', 'owner', 'platform_admin', 'support_agent'];
export const PLATFORM_CAPABILITIES = {
    'tenant.list': { roles: OASF, stepUp: false, menu: 'tenants' },
    'tenant.read': { roles: OASF, stepUp: false },
    'tenant.provision': { roles: O, stepUp: true },
    'facility_request.read': { roles: OAF, stepUp: false, menu: 'facility_requests' },
    'facility_request.write': { roles: OAF, stepUp: false },
    'facility_request.decide': { roles: O, stepUp: true },
    'branch_request.read': { roles: OA, stepUp: false, menu: 'branch_requests' },
    'owner.branch_approve': { roles: O, stepUp: true },
    'tenant.profile.update': { roles: OA, stepUp: true },
    'tenant.licence.read': { roles: OASF, stepUp: false },
    'tenant.licence.update': { roles: O, stepUp: true },
    'tenant.entitlement.update': { roles: O, stepUp: true },
    'tenant.sharing.update': { roles: O, stepUp: true },
    'tenant.commercial.update': { roles: OF, stepUp: true },
    'tenant.limits.update': { roles: O, stepUp: true },
    'tenant.directory.update': { roles: OA, stepUp: true },
    'tenant.subscription.update': { roles: OF, stepUp: true },
    'tenant.archive': { roles: O, stepUp: true },
    'tenant.suspend': { roles: O, stepUp: true },
    'tenant.freeze': { roles: OA, stepUp: true },
    'tenant.environment.update': { roles: O, stepUp: true },
    'tenant.purge.preview': { roles: O, stepUp: false },
    'tenant.purge': { roles: O, stepUp: true },
    'tenant.export': { roles: O, stepUp: true },
    'tenant.closure': { roles: O, stepUp: true },
    'tenant.group.update': { roles: OA, stepUp: true },
    'tenant.copy_masters': { roles: OA, stepUp: true },
    'tenant.branch.write': { roles: OA, stepUp: true },
    'tenant.contact.update': { roles: OA, stepUp: true },
    'tenant.user.read': { roles: OAS, stepUp: false },
    'tenant.user.support': { roles: OAS, stepUp: true },
    'tenant.user.cloud_login': { roles: OA, stepUp: true },
    'tenant.support_session.read': { roles: OAS, stepUp: false },
    'tenant.sign_in_as': { roles: O, stepUp: true },
    'tenant.sign_in_as.end': { roles: O, stepUp: false },
    'owner.live_session': { roles: O, stepUp: true },
    'owner.watch_user': { roles: O, stepUp: true },
    'owner.server_strip': { roles: O, stepUp: true },
    'owner.mail': { roles: O, stepUp: false, menu: 'mail' },
    'owner.mail.send': { roles: O, stepUp: true },
    'export.grid': { roles: OASF, stepUp: false },
    'traffic.read': { roles: OAS, stepUp: false, menu: 'traffic' },
    'person_change.read': { roles: O, stepUp: false, menu: 'person_changes' },
    'plan.read': { roles: OASF, stepUp: false },
    'plan.update': { roles: O, stepUp: true, menu: 'plans' },
    'revenue.read': { roles: OF, stepUp: false },
    'summary.read': { roles: OASF, stepUp: false, menu: 'overview' },
    'platform_audit.read': { roles: O, stepUp: false, menu: 'owner_audit' },
    'contact.read': { roles: OA, stepUp: false, menu: 'contacts' },
    'owner.read': { roles: O, stepUp: false, menu: 'owners' },
    'owner.write': { roles: O, stepUp: true },
    'staff.read': { roles: OA, stepUp: false, menu: 'staff' },
    'staff.write': { roles: O, stepUp: true },
    'staff.deactivate': { roles: O, stepUp: true },
    'announcement.write': { roles: OA, stepUp: false },
    'permission.sync': { roles: OA, stepUp: false },
    'deletion_backup.read': { roles: O, stepUp: false, menu: 'deletion_backups' },
    'backup.read': { roles: O, stepUp: false, menu: 'backups' },
    'backup.write': { roles: O, stepUp: true },
    'backup.download': { roles: O, stepUp: true },
    'deletion_backup.download': { roles: O, stepUp: true },
    'desk.ticket.read': { roles: OASF, stepUp: false, menu: 'tickets' },
    'desk.ticket.reply': { roles: OASF, stepUp: false },
    'desk.ticket.status': { roles: OAS, stepUp: false },
    'desk.renewal.read': { roles: OF, stepUp: false, menu: 'renewals' },
    'desk.renewal.decide': { roles: OF, stepUp: true },
    'client.portal': { roles: CLIENT, stepUp: false },
    'deployment.fleet': { roles: OAS, stepUp: false, menu: 'offline_installs' },
    'deployment.read': { roles: OAS, stepUp: false },
    'deployment.sync_now': { roles: OAS, stepUp: false },
    'deployment.update': { roles: O, stepUp: true },
    'deployment.command_cancel': { roles: OA, stepUp: true },
    'deployment.sync_requeue': { roles: OA, stepUp: true },
    'deployment.sync_compare': { roles: OA, stepUp: false },
    'deployment.sync_repair': { roles: OA, stepUp: true },
    'deployment.enrollment': { roles: OA, stepUp: true },
    'deployment.license_key': { roles: O, stepUp: true },
    'deployment.grace': { roles: OAS, stepUp: true },
    'alert_settings.read': { roles: OA, stepUp: false },
    'alert_settings.update': { roles: O, stepUp: true },
    'alert_settings.test': { roles: OA, stepUp: false },
    'alert.read': { roles: OAS, stepUp: false, menu: 'alerts' },
    'email.read': { roles: OA, stepUp: false },
    'email.update': { roles: O, stepUp: true },
    'email.resume': { roles: O, stepUp: true },
    'release.read': { roles: OA, stepUp: false, menu: 'releases' },
    'release.write': { roles: OA, stepUp: true },
    'country_policy.read': { roles: OA, stepUp: false },
    'country_policy.update': { roles: O, stepUp: true },
};
export const PLATFORM_CAPABILITY_CODES = Object.keys(PLATFORM_CAPABILITIES);
export function capabilityRule(code) {
    return PLATFORM_CAPABILITIES[code];
}
export function capabilityAllows(code, role) {
    if (!role)
        return false;
    return PLATFORM_CAPABILITIES[code].roles.includes(role);
}
export function ownerMenuFor(role) {
    if (!role)
        return [];
    const allowed = new Set();
    for (const code of PLATFORM_CAPABILITY_CODES) {
        const rule = PLATFORM_CAPABILITIES[code];
        if (rule.menu && rule.roles.includes(role))
            allowed.add(rule.menu);
    }
    return OWNER_MENU_KEYS.filter((key) => allowed.has(key));
}
export function menuCapability(key) {
    for (const code of PLATFORM_CAPABILITY_CODES) {
        const rule = PLATFORM_CAPABILITIES[code];
        if (rule.menu === key)
            return code;
    }
    return null;
}
//# sourceMappingURL=platform-capabilities.js.map